<span [class]="type" [ngClass]="size">
{{ title }}
</span>